const infractionOrigin = {
  DEBITED_PARTICIPANT: 'DEBITED_PARTICIPANT',
  CREDITED_PARTICIPANT: 'CREDITED_PARTICIPANT'
};

module.exports = infractionOrigin;
